﻿window.lstPrenom = null;
window.inLoadLstNomPrenom = false
window.cNomPrenom = function (bddRef, valeur) {

    var Me = this

    if (lstPrenom == null && !inLoadLstNomPrenom) {
        inLoadLstNomPrenom = true
        bddRef.mAjaxCall({ command: "getlstprenom" }, function (data) {
            lstPrenom = ((typeof data.lstprenom == 'undefined') ? [] : JSON.parse(data.lstprenom))
        })
    }

    function mNettoie() {
        while (valeur.contains("  ")) valeur = valeur.remplacerTout("  ", " ")
        valeur = valeur.remplacerTout(".", " ")
        valeur = valeur.remplacerTout("-", " ")
    }

    this.nom = ""
    this.prenom = ""
    this.sexe = ""
    this.normalise = "0"
    this.id_titre = null

    function mTraiteNomPrenom() {
        mNettoie()
        var nomPrenomSansAccent = valeur.sansAccent().toLowerCase()

        var lstSansAccent = []
        nomPrenomSansAccent.split(" ").forEach(function (o) { lstSansAccent.push(o) })
        var lstOrignal = []
        valeur.split(" ").forEach(function (o) { lstOrignal.push(o) })

        var txt = ""
        var txtReelle = ""
        var idxPrenom = null
        for (var i = 0; i < lstSansAccent.length; i++) {
            if (txt.length > 0) { txt += "-"; txtReelle += "-"; }
            txt += lstSansAccent[i]
            txtReelle += lstOrignal[i]
            var lstResultMots = ((lstPrenom == null) ? [] : lstPrenom.filter(function (o) { return o.p == txt.toLowerCase() }))
            if (lstResultMots.length > 0) {
                Me.prenom = txtReelle
                Me.sexe = lstResultMots[0].s
                idxPrenom = i
            }
        }

        if (idxPrenom != null) {
            //on a trouvé un prénom
            txtReelle = ""
            for (var i = idxPrenom + 1; i < lstSansAccent.length; i++) {
                if (txtReelle.length > 0) { txtReelle += "-"; }
                txtReelle += lstOrignal[i]
            }
            Me.nom = txtReelle
            Me.normalise = "1"
        } else {
            //on a rien trouvé
            //on cherche dans l'autre sens
            txt = ""
            txtReelle = ""
            for (var i = lstSansAccent.length - 1; i >= 0; i--) {
                if (txt.length > 0) { txt = "-" + txt; txtReelle = "-" + txtReelle; }
                txt = lstSansAccent[i] + txt
                txtReelle = lstOrignal[i] + txtReelle
                var lstResultMots = ((lstPrenom == null) ? [] : lstPrenom.filter(function (o) { return o.p == txt.toLowerCase() }))
                if (lstResultMots.length > 0) {
                    Me.prenom = txtReelle
                    Me.sexe = lstResultMots[0].s
                    idxPrenom = i
                }
            }
            if (idxPrenom != null) {
                //on a trouvé un prénom
                txtReelle = ""
                for (var i = idxPrenom - 1; i >= 0; i--) {
                    if (txtReelle.length > 0) { txtReelle = "-" + txtReelle; }
                    txtReelle = lstOrignal[i] + txtReelle
                }
                Me.nom = txtReelle
                Me.normalise = "1"
            }
        }

        if (Me.normalise == "1") {
            var titre = bddRef.mGetArray("titre").filterFirst(function (o) { return o.sexe == Me.sexe })[0]
            Me.id_titre = null
            if (typeof titre != 'undefined') Me.id_titre = titre.id_titre
            Me.mMiseEnforme()
        }
        else { Me.nom = valeur }
    }

    this.mMiseEnforme = function () {
        Me.nom = Me.nom.remplacerTout(" ", "-").toUpperCase()
        Me.prenom = Me.prenom.remplacerTout(" ", "-")

        var prenomMiseEnforme = ""
        Me.prenom.toLowerCase().split("-").forEach(function (prenom1) {
            var eleApostrophe = ""
            prenom1.split("'").forEach(function (prenom2) {
                eleApostrophe = prenom2.substring(0, 1).toUpperCase()
                if (prenom2.length > 1) eleApostrophe += prenom2.substring(1, prenom2.length)
            })
            if (prenomMiseEnforme.length > 0) prenomMiseEnforme += "-"
            prenomMiseEnforme += eleApostrophe
        })
        Me.prenom = prenomMiseEnforme

    }

    if (typeof valeur != 'undefined') mTraiteNomPrenom();

    this.mGetDisplayMiseEnForme = function (nom, prenom, idTitre) {
        var txt = ""
        if (nom != null && nom.length > 0) {
            txt = "" + nom.toUpperCase() + ""
        }
        if (prenom != null && prenom.length > 0) {
            if (txt.length > 0) txt += " "
            txt += "" + prenom + ""
        }
        if (txt.length > 0 && typeof idTitre != 'undefined' && idTitre != null) {
            var titre = bddRef.mGetArray("titre").filter(function (o) { return o.id_titre == idTitre })[0]
            if (typeof titre != 'undefined') txt += " (" + titre.lib_court + ")"
        }
        return txt
    }

}